import _toArray from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _slicedToArray from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { produce } from 'immer';
import { atom, useAtom } from 'jotai';
import { useCallback } from 'react';
function atomWithImmer(initialValue) {
  var anAtom = atom(initialValue, function (get, set, fn) {
    return set(anAtom, produce(get(anAtom), typeof fn === "function" ? fn : function () {
      return fn;
    }));
  });
  return anAtom;
}
function useImmerAtom(anAtom, scope) {
  var _useAtom = useAtom(anAtom, scope),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    state = _useAtom2[0],
    setState = _useAtom2[1];
  var setStateWithImmer = useCallback(function (fn) {
    return setState(produce(function (draft) {
      return fn(draft);
    }));
  }, [setState]);
  return [state, setStateWithImmer];
}
var getWeakCacheItem = function getWeakCacheItem(cache, deps) {
  while (true) {
    var _deps = deps,
      _deps2 = _toArray(_deps),
      dep = _deps2[0],
      rest = _deps2.slice(1);
    var entry = cache.get(dep);
    if (!entry) {
      return;
    }
    if (!rest.length) {
      return entry[1];
    }
    cache = entry[0];
    deps = rest;
  }
};
var setWeakCacheItem = function setWeakCacheItem(cache, deps, item) {
  while (true) {
    var _deps3 = deps,
      _deps4 = _toArray(_deps3),
      dep = _deps4[0],
      rest = _deps4.slice(1);
    var entry = cache.get(dep);
    if (!entry) {
      entry = [new WeakMap()];
      cache.set(dep, entry);
    }
    if (!rest.length) {
      entry[1] = item;
      return;
    }
    cache = entry[0];
    deps = rest;
  }
};
var createMemoizeAtom = function createMemoizeAtom() {
  var cache = new WeakMap();
  var memoizeAtom = function memoizeAtom(createAtom, deps) {
    var cachedAtom = getWeakCacheItem(cache, deps);
    if (cachedAtom) {
      return cachedAtom;
    }
    var createdAtom = createAtom();
    setWeakCacheItem(cache, deps, createdAtom);
    return createdAtom;
  };
  return memoizeAtom;
};
var memoizeAtom = createMemoizeAtom();
function withImmer(anAtom) {
  return memoizeAtom(function () {
    var derivedAtom = atom(function (get) {
      return get(anAtom);
    }, function (get, set, fn) {
      return set(anAtom, produce(get(anAtom), typeof fn === "function" ? fn : function () {
        return fn;
      }));
    });
    return derivedAtom;
  }, [anAtom]);
}
export { atomWithImmer, useImmerAtom, withImmer };